import { LinearProgress, Typography, Stack } from "@mui/material";

export interface StepProgressProps {
  step: number;
  totalSteps: number;
}

export function StepProgress({ step, totalSteps }: StepProgressProps) {
  const clamped = Math.min(Math.max(step, 1), totalSteps);
  const value = (clamped / totalSteps) * 100;

  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      sx={{ width: "100%" }}
    >
      <LinearProgress
        variant="determinate"
        value={value}
        sx={{
          flex: 1,
          height: 10,
          borderRadius: 999,
          backgroundColor: "#ECEFF2",
          "& .MuiLinearProgress-bar": {
            backgroundColor: "#39B2AC",
            borderRadius: 999,
          },
        }}
      />

      <Typography
        variant="body2"
        sx={{
          minWidth: 32,
          textAlign: "right",
          fontSize: "0.8rem",
          color: "#6A7A89",
          fontWeight: 500,
        }}
      >
        {clamped}/{totalSteps}
      </Typography>
    </Stack>
  );
}
